$(function() {
  console.log("custom ready!!!");

    console.log("first_request", first_request);
    
    // Solo redirigir si es la primera visita Y no es una página de producto
    if(request_host.includes('navala.com.co') && 
       request_path !== '/pages/home-naval' && 
       first_request == ""){
      console.log("navala.com.co");

      let attributes = {
        attributes: {
          first_request: "true"
        }
      };

      console.log("redirect");
      location.href = '/pages/home-naval';

      /*
      updateCartAttribute(attributes, function(data){
        console.log(data);
        location.href = '/pages/home-naval';
      });
      */
    }

    $(document).on('click', '.remove_all_items', function(){
        $("body").addClass("loading");
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function(cart) {
                $("body").removeClass("loading");
                location.reload();
            }
        });
    });

});


    // Selecciona todos los botones para abrir modales
const botonesModal1 = document.querySelectorAll('.boton-modal');

// Agrega un evento click a cada botón
botonesModal1.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = document.querySelector(boton.dataset.modal); // Encuentra el modal correspondiente al botón
    modal.classList.add('mostrar'); // Agrega la clase "mostrar" para mostrar el modal
  });
});

// Selecciona todos los botones para cerrar modales
const botonesCerrar1 = document.querySelectorAll('.modal-cerrar');

// Agrega un evento click a cada botón
botonesCerrar1.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = boton.closest('.modal-custom'); // Encuentra el modal más cercano al botón
    modal.classList.remove('mostrar'); // Quita la clase "mostrar" para ocultar el modal
  });
});

// Cierra el modal si se hace clic fuera del contenido
window.addEventListener('click', evento => {
  const modales = document.querySelectorAll('.modal-custom');
  modales.forEach(modal => {
    if (evento.target === modal) {
      modal.classList.remove('mostrar');
    }
  });
});

// Cierra el modal si se presiona la tecla Esc
window.addEventListener('keydown', evento => {
  const modales = document.querySelectorAll('.modal-custom');
  modales.forEach(modal => {
    if (evento.key === 'Escape') {
      modal.classList.remove('mostrar');
    }
  });
});

// Función para activar automáticamente el filtro de disponibilidad
// cuando se selecciona cualquier otro filtro
(function() {
  'use strict';
  
  // Bandera para evitar loops infinitos
  var isAutoActivating = false;
  
  // Función para encontrar el checkbox del filtro de disponibilidad
  function findAvailabilityCheckbox() {
    // Nombres posibles del filtro de disponibilidad
    var availabilityFilterNames = [
      'disponibilidad',
      'availability', 
      'en existencia',
      'stock',
      'disponible',
      'availability status'
    ];
    
    // Valores posibles del filtro de disponibilidad
    var availabilityValues = [
      'en stock',
      'in stock',
      'disponible',
      'available',
      'en existencia'
    ];
    
    var availabilityCheckbox = null;
    
    // Buscar en todos los filtros dinámicos
    $('.dyFilters').each(function() {
      var $filterBox = $(this);
      var filterTitle = $filterBox.find('.flTtl span').first().text().trim().toLowerCase();
      
      // Verificar si este es el filtro de disponibilidad
      var isAvailabilityFilter = false;
      availabilityFilterNames.forEach(function(name) {
        if (filterTitle.includes(name.toLowerCase())) {
          isAvailabilityFilter = true;
        }
      });
      
      if (isAvailabilityFilter) {
        // Buscar el checkbox que corresponde a "En stock" o "Disponible"
        $filterBox.find('input.dyfl[type="checkbox"]').each(function() {
          var $checkbox = $(this);
          var labelText = $checkbox.closest('label').text().trim().toLowerCase();
          var checkboxValue = $checkbox.val().toLowerCase();
          
          // Buscar valores como "en stock", "disponible", "in stock", "available"
          var isAvailabilityValue = false;
          availabilityValues.forEach(function(val) {
            if (labelText.includes(val) || checkboxValue.includes(val)) {
              isAvailabilityValue = true;
            }
          });
          
          if (isAvailabilityValue) {
            availabilityCheckbox = $checkbox;
            return false; // Salir del loop
          }
        });
        
        if (availabilityCheckbox) {
          return false; // Salir del loop
        }
      }
    });
    
    return availabilityCheckbox;
  }
  
  // Función para activar el filtro de disponibilidad
  function findAndActivateAvailabilityFilter() {
    if (isAutoActivating) {
      return false;
    }
    
    var availabilityCheckbox = findAvailabilityCheckbox();
    
    // Si encontramos el filtro de disponibilidad y no está activo, activarlo
    if (availabilityCheckbox && !availabilityCheckbox.is(':checked')) {
      isAutoActivating = true;
      console.log('Activando automáticamente el filtro de disponibilidad');
      availabilityCheckbox.prop('checked', true);
      
      // Resetear la bandera después de un momento
      setTimeout(function() {
        isAutoActivating = false;
      }, 300);
      
      return true;
    }
    
    return false;
  }
  
  // Función para desactivar el filtro de disponibilidad
  function findAndDeactivateAvailabilityFilter() {
    if (isAutoActivating) {
      return false;
    }
    
    var availabilityCheckbox = findAvailabilityCheckbox();
    
    // Si encontramos el filtro de disponibilidad y está activo, desactivarlo
    if (availabilityCheckbox && availabilityCheckbox.is(':checked')) {
      isAutoActivating = true;
      console.log('Desactivando automáticamente el filtro de disponibilidad');
      availabilityCheckbox.prop('checked', false);
      
      // Actualizar el estado previo
      availabilityCheckbox.data('previous-state', false);
      
      // Disparar el evento change para aplicar el cambio
      setTimeout(function() {
        // Usar el evento nativo para evitar que nuestro listener lo procese
        var changeEvent = new Event('change', { bubbles: true });
        availabilityCheckbox[0].dispatchEvent(changeEvent);
        
        // Resetear la bandera después de un momento
        setTimeout(function() {
          isAutoActivating = false;
        }, 500);
      }, 100);
      
      return true;
    }
    
    return false;
  }
  
  // Función para verificar si hay otros filtros activos (excluyendo disponibilidad)
  function hasOtherActiveFilters() {
    var hasOtherFilters = false;
    
    $('.dyFilters').each(function() {
      var $filterBox = $(this);
      var filterTitle = $filterBox.find('.flTtl span').first().text().trim().toLowerCase();
      var availabilityFilterNames = ['disponibilidad', 'availability', 'en existencia', 'stock', 'disponible'];
      var isAvailabilityFilter = false;
      
      availabilityFilterNames.forEach(function(name) {
        if (filterTitle.includes(name.toLowerCase())) {
          isAvailabilityFilter = true;
        }
      });
      
      // Si NO es el filtro de disponibilidad y tiene checkboxes marcados
      if (!isAvailabilityFilter && $filterBox.find('.dyfl:checked').length > 0) {
        hasOtherFilters = true;
        return false; // Salir del loop
      }
    });
    
    return hasOtherFilters;
  }
  
  // Interceptar el evento change usando addEventListener con capture para ejecutarlo ANTES
  // que el código de theme.js (que usa jQuery)
  document.addEventListener('change', function(e) {
    // Solo procesar si es un checkbox de filtro dinámico
    if (!e.target.matches('.dyfl') && !e.target.matches('input.dyfl')) {
      return;
    }
    
    var $changedFilter = $(e.target);
    var wasChecked = $changedFilter.data('previous-state');
    var isNowChecked = $changedFilter.is(':checked');
    
    // Guardar el estado actual para la próxima vez
    $changedFilter.data('previous-state', isNowChecked);
    
    // Si estamos auto-activando, dejar que el evento continúe normalmente
    if (isAutoActivating) {
      return;
    }
    
    // Verificar si el filtro cambiado es el de disponibilidad
    var $filterBox = $changedFilter.closest('.dyFilters');
    var isAvailabilityFilter = false;
    
    if ($filterBox.length) {
      var filterTitle = $filterBox.find('.flTtl span').first().text().trim().toLowerCase();
      var availabilityFilterNames = ['disponibilidad', 'availability', 'en existencia', 'stock', 'disponible'];
      
      availabilityFilterNames.forEach(function(name) {
        if (filterTitle.includes(name.toLowerCase())) {
          isAvailabilityFilter = true;
        }
      });
    }
    
    // Si el filtro cambiado NO es el de disponibilidad
    if (!isAvailabilityFilter) {
      // Si se activó un filtro, activar el de disponibilidad
      if (isNowChecked) {
        findAndActivateAvailabilityFilter();
      } 
      // Si se desactivó un filtro, verificar si quedan otros filtros activos
      else if (!isNowChecked) {
        // El código de theme.js hace una petición AJAX que actualiza el DOM
        // Necesitamos esperar a que el AJAX complete antes de verificar
        var checkAfterAjax = setInterval(function() {
          // Verificar si el body ya no tiene la clase 'loading' (significa que el AJAX terminó)
          if (!$('body').hasClass('loading') && !$('body').hasClass('hideOverly')) {
            clearInterval(checkAfterAjax);
            
            // Esperar un poco más para que el DOM se actualice completamente
            setTimeout(function() {
              // Verificar si quedan otros filtros activos
              if (!hasOtherActiveFilters()) {
                // Si no quedan otros filtros, desactivar el de disponibilidad
                console.log('No quedan otros filtros activos, desactivando disponibilidad');
                findAndDeactivateAvailabilityFilter();
              } else {
                console.log('Aún hay otros filtros activos, manteniendo disponibilidad');
              }
            }, 300);
          }
        }, 50);
        
        // Timeout de seguridad por si el AJAX nunca termina (máximo 5 segundos)
        setTimeout(function() {
          clearInterval(checkAfterAjax);
          // Verificar una última vez
          if (!hasOtherActiveFilters()) {
            console.log('Timeout: No quedan otros filtros activos, desactivando disponibilidad');
            findAndDeactivateAvailabilityFilter();
          }
        }, 5000);
      }
    }
  }, true); // true = usar capture phase para ejecutar ANTES
  
  // Interceptar cuando se elimina un filtro usando el botón de remover
  $(document).on('click', '.removefl, .removeAll', function(e) {
    // Esperar a que el AJAX complete
    var checkAfterAjax = setInterval(function() {
      if (!$('body').hasClass('loading') && !$('body').hasClass('hideOverly')) {
        clearInterval(checkAfterAjax);
        setTimeout(function() {
          // Verificar si quedan otros filtros activos
          if (!hasOtherActiveFilters()) {
            // Si no quedan otros filtros, desactivar el de disponibilidad
            findAndDeactivateAvailabilityFilter();
          }
        }, 300);
      }
    }, 50);
    
    setTimeout(function() {
      clearInterval(checkAfterAjax);
    }, 5000);
  });
  
  // Interceptar después de que el AJAX complete para verificar el estado
  // Esto se ejecuta después de que theme.js actualice el DOM
  $(document).ajaxComplete(function(event, xhr, settings) {
    // Solo procesar si es una petición de filtros (no otras peticiones AJAX)
    if (settings.url && (settings.url.indexOf(window.location.pathname) !== -1 || settings.url.indexOf('/collections/') !== -1)) {
      // Esperar a que el DOM se actualice completamente
      setTimeout(function() {
        // Reinicializar el estado previo de los checkboxes después del AJAX
        $('.dyfl').each(function() {
          $(this).data('previous-state', $(this).is(':checked'));
        });
        
        // Verificar si hay otros filtros activos
        var hasOthers = hasOtherActiveFilters();
        var availabilityCheckbox = findAvailabilityCheckbox();
        var availabilityIsChecked = availabilityCheckbox && availabilityCheckbox.is(':checked');
        
        console.log('AJAX completo - Otros filtros:', hasOthers, 'Disponibilidad activa:', availabilityIsChecked);
        
        // Si no hay otros filtros pero el de disponibilidad está activo, desactivarlo
        if (!hasOthers && availabilityIsChecked && !isAutoActivating) {
          console.log('AJAX completo: No hay otros filtros, desactivando disponibilidad');
          findAndDeactivateAvailabilityFilter();
        }
      }, 600);
    }
  });
  
  // Inicializar el estado previo de los checkboxes y activar disponibilidad si es necesario
  $(document).ready(function() {
    setTimeout(function() {
      // Inicializar el estado previo de todos los checkboxes
      $('.dyfl').each(function() {
        $(this).data('previous-state', $(this).is(':checked'));
      });
      
      // Verificar si hay filtros activos (excepto disponibilidad)
      var hasOtherFilters = hasOtherActiveFilters();
      var hasAvailabilityFilter = false;
      
      var availabilityCheckbox = findAvailabilityCheckbox();
      if (availabilityCheckbox && availabilityCheckbox.is(':checked')) {
        hasAvailabilityFilter = true;
      }
      
      // Si hay otros filtros activos pero no el de disponibilidad, activarlo
      if (hasOtherFilters && !hasAvailabilityFilter) {
        findAndActivateAvailabilityFilter();
        // Disparar el evento change para aplicar el filtro
        setTimeout(function() {
          var $availabilityCheckbox = findAvailabilityCheckbox();
          if ($availabilityCheckbox && $availabilityCheckbox.length) {
            $availabilityCheckbox.trigger('change');
          }
        }, 100);
      }
      // Si no hay otros filtros pero el de disponibilidad está activo, desactivarlo
      else if (!hasOtherFilters && hasAvailabilityFilter) {
        findAndDeactivateAvailabilityFilter();
      }
    }, 1500);
  });
})();
